import React from 'react';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';

export function EmptyState() {
  return (
    <div className="p-20 text-center bg-white rounded-2xl border border-gray-200">
      <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center text-gray-400">
        <FlightTakeoffIcon sx={{ fontSize: 48 }} />
      </div>
      <h3 className="m-0 mb-2 text-2xl font-semibold text-gray-900">
        No Flight Records
      </h3>
      <p className="m-0 text-gray-500 text-lg">
        Click <strong className="text-primary-500">+ Add Record</strong> to create your first
        master flight schedule.
      </p>
    </div>
  );
}
